import { h } from 'preact';
import Carousel from '../Carousel/Carousel';
import Asset from '../Asset/Asset';
import { Axis, CarouselLoop, MediaSymbolTypes, ZoomType } from '../../typing/enums';
import { getTransformation } from '../../utils/assetHelpers';
import NavButton from '../NavButton/NavButton';
import { getAltText } from '../../utils/accessibility';
import { CarouselViewerWrapper } from './CarouselViewer.styled';
import { t } from '../../common/text';
import { withContext } from '../../common/context';
import { CAROUSEL_DEFAULTS } from '../../config/defaults';

const CarouselViewer = props => {
  const { config } = props.context;

  const navigationProps = {
    navigation: props.navigation,
    offset: config.selectNavigationOffset(),
    ...config.selectNavigationButtonProps()
  };

  const zoomType = config.selectZoomPropsType();
  const behindAnOpenPopup = props.zoomState > -1 && zoomType === ZoomType.POPUP && !props.inPopup;

  const inPopupWithoutMultiZoom = props.inPopup && !config.selectZoomPropsSteps();

  const swipableItem = [MediaSymbolTypes.VIDEO, MediaSymbolTypes.IMAGE].includes(
    props.items[props.index]?.mediaType
  );

  const carouselJump = config.selectCarouselLoop() === CarouselLoop.JUMP;

  return (
    <CarouselViewerWrapper
      data-test="carousel-viewer-wrap"
      className="carousel-viewer-wrap"
      borderWidth={config.selectBorderWidth()}
      borderColor={config.selectBorderColor()}
      radius={config.selectRadius()}
    >
      <Carousel
        {...CAROUSEL_DEFAULTS}
        index={props.index}
        perView={1}
        itemWidth={props.width}
        itemHeight={props.height}
        spacing={0}
        transition={config.selectTransition()}
        axis={Axis.HORIZONTAL}
        navigation={false}
        onItemSwipe={props.onItemSwipe || undefined}
        isZoomed={props.zoomState > -1}
        swipableItem={swipableItem}
        touchAction={config.selectPreventPageScroll() ? 'none' : 'pan-y'}
      >
        {props.items.map((item, index) => {
          // Main view - classic mode
          const altText = getAltText(config, item, index, props.items.length);
          const inView = index === props.index && !behindAnOpenPopup;

          return (
            <Asset
              {...item}
              focusable={inView}
              key={item.assetIndex}
              index={props.index}
              mediaType={item.mediaType}
              resourceType={item.resourceType}
              width={props.width}
              height={props.height}
              useBreakpoint={true}
              roundHeightToBreakpoint={props.inPopup}
              inView={inView}
              inPopup={props.inPopup}
              setZoom={props.setZoom}
              zoomState={index === props.zoomState}
              zoom={config.selectZoom() && !inPopupWithoutMultiZoom}
              transformation={getTransformation(
                { ...props.transformation, ...item.transformation },
                config
              )}
              assetTransformation={item.transformation}
              alt={altText}
            />
          );
        })}
      </Carousel>
      <NavButton
        {...navigationProps}
        direction="left"
        onClick={props.prevItem}
        position={config.selectNavigationPosition()}
        disabled={props.index <= 0 && !carouselJump}
        aria-label={t('previous')}
      />
      <NavButton
        {...navigationProps}
        direction="right"
        onClick={props.nextItem}
        position={config.selectNavigationPosition()}
        disabled={props.index >= props.items.length - 1 && !carouselJump}
        aria-label={t('next')}
      />
    </CarouselViewerWrapper>
  );
};

export default withContext(CarouselViewer);
